var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.25C7.41421 11.25 7.75 11.5858 7.75 12V21C7.75 21.4142 7.41421 21.75 7 21.75C6.58579 21.75 6.25 21.4142 6.25 21V12C6.25 11.5858 6.58579 11.25 7 11.25ZM17 11.25C17.4142 11.25 17.75 11.5858 17.75 12V21C17.75 21.4142 17.4142 21.75 17 21.75C16.5858 21.75 16.25 21.4142 16.25 21V12C16.25 11.5858 16.5858 11.25 17 11.25Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 8C1.75 6.48122 2.98122 5.25 4.5 5.25H19.5C21.0188 5.25 22.25 6.48122 22.25 8V19.5C22.25 21.0188 21.0188 22.25 19.5 22.25H4.5C2.98122 22.25 1.75 21.0188 1.75 19.5V8ZM4.5 6.75C3.80964 6.75 3.25 7.30964 3.25 8V19.5C3.25 20.1904 3.80964 20.75 4.5 20.75H19.5C20.1904 20.75 20.75 20.1904 20.75 19.5V8C20.75 7.30964 20.1904 6.75 19.5 6.75H4.5Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13516 3.25251C8.25832 2.39036 8.9967 1.75 9.86757 1.75H14.133C15.0039 1.75 15.7422 2.39038 15.8654 3.25248L15.8654 3.25253L16.2427 5.89395L14.7578 6.10605L14.3805 3.46468C14.3805 3.46466 14.3805 3.46465 14.3805 3.46463C14.3629 3.34146 14.2574 3.25 14.133 3.25H9.86757C9.74315 3.25 9.63768 3.34149 9.62009 3.46463L9.62009 3.46465L9.24274 6.10607L7.75781 5.89393L8.13516 3.25253C8.13516 3.25252 8.13516 3.25252 8.13516 3.25251Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBriefcase);
export default __webpack_public_path__ + "static/media/ic-briefcase.044c86c7756ebb9aa05a7d9404632d0b.svg";
export { ForwardRef as ReactComponent };